import { render } from "./language-switcher.vue?vue&type=template&id=0e0ecf30&ts=true"
import script from "./language-switcher.vue?vue&type=script&lang=ts"
export * from "./language-switcher.vue?vue&type=script&lang=ts"

import "./language-switcher.vue?vue&type=style&index=0&id=0e0ecf30&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__